import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment, HttpHeadersService } from '@perval/shared';
import { filter, firstValueFrom, map, tap } from 'rxjs';
import {
  SharedStateLegacyService,
  StateKey,
} from '../../shared/services/stockage/shared-state-legacy.service';
import { Credit } from '../models/credit';
import {
  fromOrderHttpToOrder,
  fromPackHttpToPack,
  OffersHttp,
  OrderHttp,
} from './mappers/pack.mapper';

@Injectable({
  providedIn: 'root',
})
export class CreditService {
  private readonly mainUrl = `${environment.baseApiUrl}/perval-credits`;

  constructor(
    private readonly http: HttpClient,
    private readonly httpHeadersServiceService: HttpHeadersService,
    private readonly sharedStateLegacyService: SharedStateLegacyService,
  ) {}

  async getAllPacks(): Promise<Credit.Pack[]> {
    return firstValueFrom(
      this.http
        .get<OffersHttp>(`${this.mainUrl}/offers`, {
          headers:
            await this.httpHeadersServiceService.getHeadersWithPervalContext(),
        })
        .pipe(map((packs) => packs.items.map(fromPackHttpToPack))),
    );
  }

  async commander(commande: Credit.Commande): Promise<Credit.Commande> {
    return firstValueFrom(
      this.http
        .post<OrderHttp>(
          `${this.mainUrl}/orders`,
          {
            offer_id: commande.pack?.id,
            is_replenishment: commande.isRenouvellementAuto,
          },
          {
            headers:
              await this.httpHeadersServiceService.getHeadersWithPervalContext(),
          },
        )
        .pipe(
          map((order) => fromOrderHttpToOrder(order)),
          filter((order) => order.totalCredit !== undefined),
          tap((order) =>
            this.sharedStateLegacyService.setItem(
              StateKey.solde,
              (order.totalCredit as number).toString(),
            ),
          ),
          tap(() =>
            this.sharedStateLegacyService.setItem(
              StateKey.renouvellement,
              (!!commande.isRenouvellementAuto).toString(),
            ),
          ),
        ),
    );
  }
}
